import { formatDateTime, formatRelative, toIso } from '../../../core/utils/date';

export default function RelativeTime({ value, className }) {
    if (!value) return <span className={className}>—</span>;
    return (
        <time className={className} dateTime={toIso(value)} title={formatDateTime(value)}>
            {formatRelative(value)}
        </time>
    );
}
